import { httpsCallable } from "firebase/functions";
import { functions } from "../../firebase/firebase";

export async function SendSupportEmail( ContactName: string, ContactEmail: string, ContactMessage: string ) {
    const sendSupportEmail = httpsCallable(functions, 'SendSupportEmail');
    return sendSupportEmail({ ContactName, ContactEmail, ContactMessage });
}